"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestRackEvStatusValidation = void 0;
class TestRackEvStatusValidation {
    static isValid(entity) {
        // Validate entity.contactor_en for existence and correct type.
        if (entity.contactor_en == undefined)
            return false;
        if (typeof entity.contactor_en !== "boolean")
            return false;
        // Validate entity.ct0_aux for existence and correct type.
        if (entity.ct0_aux == undefined)
            return false;
        if (typeof entity.ct0_aux !== "boolean")
            return false;
        // Validate entity.ct1_aux for existence and correct type.
        if (entity.ct1_aux == undefined)
            return false;
        if (typeof entity.ct1_aux !== "boolean")
            return false;
        // Validate entity.contactor_fsm_state for existence and correct type.
        if (entity.contactor_fsm_state == undefined)
            return false;
        if (typeof entity.contactor_fsm_state !== "number")
            return false;
        // Validate entity.imd_fsm_state for existence and correct type.
        if (entity.imd_fsm_state == undefined)
            return false;
        if (typeof entity.imd_fsm_state !== "number")
            return false;
        // Validate entity.tms320_connected for existence and correct type.
        if (entity.tms320_connected == undefined)
            return false;
        if (typeof entity.tms320_connected !== "boolean")
            return false;
        // Validate entity.v_cp_pos_mv for existence and correct type.
        if (entity.v_cp_pos_mv == undefined)
            return false;
        if (typeof entity.v_cp_pos_mv !== "number")
            return false;
        // Validate entity.v_cp_neg_mv for existence and correct type.
        if (entity.v_cp_neg_mv == undefined)
            return false;
        if (typeof entity.v_cp_neg_mv !== "number")
            return false;
        // Validate entity.v_pp_pos_mv for existence and correct type.
        if (entity.v_pp_pos_mv == undefined)
            return false;
        if (typeof entity.v_pp_pos_mv !== "number")
            return false;
        // Validate entity.v_pp_neg_mv for existence and correct type.
        if (entity.v_pp_neg_mv == undefined)
            return false;
        if (typeof entity.v_pp_neg_mv !== "number")
            return false;
        // Validate entity.v_hvdc for existence and correct type.
        if (entity.v_hvdc == undefined)
            return false;
        if (typeof entity.v_hvdc !== "number")
            return false;
        // Validate entity.i_hvdc for existence and correct type.
        if (entity.i_hvdc == undefined)
            return false;
        if (typeof entity.i_hvdc !== "number")
            return false;
        // Validate entity.v_dc_plus_minus for existence and correct type.
        if (entity.v_dc_plus_minus == undefined)
            return false;
        if (typeof entity.v_dc_plus_minus !== "number")
            return false;
        // Validate entity.v_dc_plus_pe for existence and correct type.
        if (entity.v_dc_plus_pe == undefined)
            return false;
        if (typeof entity.v_dc_plus_pe !== "number")
            return false;
        // Validate entity.v_dc_minus_pe for existence and correct type.
        if (entity.v_dc_minus_pe == undefined)
            return false;
        if (typeof entity.v_dc_minus_pe !== "number")
            return false;
        // Validate entity.fault_hvdc_ovp for existence and correct type.
        if (entity.fault_hvdc_ovp == undefined)
            return false;
        if (typeof entity.fault_hvdc_ovp !== "boolean")
            return false;
        // Validate entity.fault_hvdc_ocp for existence and correct type.
        if (entity.fault_hvdc_ocp == undefined)
            return false;
        if (typeof entity.fault_hvdc_ocp !== "boolean")
            return false;
        return true;
    }
}
exports.TestRackEvStatusValidation = TestRackEvStatusValidation;
